import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { NavLink, useLocation } from "react-router-dom";

import {
  aboutProgramRoute,
  dashboard as dashboardRoute,
  institutions as institutionsRoute,
  izjavaOPristupacnostiRoute,
} from "../../routes/routes";
import styles from "./Navigation.module.scss";

export default function Navigation() {
  const { pathname } = useLocation();

  const resolveLinkVisibility = (): boolean => {
    if (
      pathname === dashboardRoute() ||
      pathname === institutionsRoute() ||
      pathname === aboutProgramRoute() ||
      pathname === izjavaOPristupacnostiRoute() ||
      pathname === "/"
    ) {
      return true;
    }
    return false;
  };

  return (
    <>
      <Navbar className={styles.navbar} expand="sm" role="navigation">
        <Container>
          {resolveLinkVisibility() && (
            <Nav>
              <Nav.Link as={NavLink} to={dashboardRoute()}>
                Radna ploha
              </Nav.Link>
              <Nav.Link as={NavLink} to={institutionsRoute()}>
                Ustanove i programi
              </Nav.Link>
            </Nav>
          )}
        </Container>
      </Navbar>
    </>
  );
}
